import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Heading from '../../elements/Heading';
import animations from './animations';

class FiveColumn extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            items: []
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState(this.props.data);
            this.controller = animations.initialise(this);
        }
    }

    componentWillUnmount() {
        animations.destroy(this.controller);
    }
    
    render() {
        const Items = this.state.items.map((item, key) => {
            return (
                <div key={key} className="column">
                    <h3 dangerouslySetInnerHTML={{__html: item.title}} />
                    <p dangerouslySetInnerHTML={{__html: item.description}} />
                    <Link to={item.url} dangerouslySetInnerHTML={{__html: item.urlTitle}} />
                </div>
            );
        });
        
        return (
            <section className="five-column">
                <div className="row">
                    <div className="col-md-10 col-md-offset-1 col-xs-12 centered">
						{this.state.title ? <Heading title={this.state.title} subTitle={this.state.subTitle} /> : ''}
                        <div className="columns">
                            {Items}
                        </div>
                    </div>
                </div>
            </section>            
        );
    }
    
}

export default FiveColumn;


// WEBPACK FOOTER //
// ./resources/assets/js/modules/FiveColumn/FiveColumn.js